<script setup>
import SiteContent from '#/layout/components/SiteContent.vue'
</script>

<template>
  <SiteContent />
</template>
